import config from '../../config'

import { IGetPostRequest } from '../../interfaces'

const getAddChecklistMutationRequest: IGetPostRequest = params => {
  const { airportId } = params

  return {
    method: 'post',
    url: `${config.baseUrl}/${airportId}/Checklists/instances`,
  }
}

export default getAddChecklistMutationRequest
